import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';
import { useState } from 'react';
import { Modal } from '@fasstech/middle-design-system';
import FooterExtraForm from '@@app/extra/FooterExtraForm';

const Footer = ({ getMiddleBoolean, getMiddleText }) => {
  const [displayPersonalDataModal, setDisplayPersonalDataModal] = useState(false);

  return (
    <>
      {getMiddleBoolean('PROCESSDEVENTE_DONNEES_PERSONNELLES_EST_NECESSAIRE') && (
        <div
          className="w-full bg-white flex justify-center p-4 underline cursor-pointer"
          onClick={() => setDisplayPersonalDataModal(true)}>
          {getMiddleText('PROCESSDEVENTE_DONNEES_PERSONNELLES_LIEN_LABEL')}
        </div>
      )}
      <Modal
        isDisplayed={displayPersonalDataModal}
        onClose={() => setDisplayPersonalDataModal(false)}
        icon="circleLegal"
        iconSize={60}
        className="max-w-2xl max-h-[95vh]"
        containerClassName="px-3">
        <>
          <div className="text-lg sm:text-xl md:text-2xl! font-semibold mb-4">
            {getMiddleText('PROCESSDEVENTE_DONNEES_PERSONNELLES_LIEN_LABEL')}
          </div>

          <div
            className="max-h-[200px] md:max-h-[500px] overflow-y-auto text-[10px] sm:text-xs md:text-sm text-left"
            dangerouslySetInnerHTML={{
              __html: getMiddleText('PROCESSDEVENTE_DONNEES_PERSONNELLES_TEXT')
            }}></div>
          <FooterExtraForm/>
        </>
      </Modal>
    </>
  );
};

export default withMiddleFeatures(Footer);
